import React from 'react';
import './index.css';

// style={{ width:20, height: 20, borderRadius: '50%', backgroundColor:'blue', borderWidth: 1, borderColor: '#13b9ab', justifyContent: 'center', alignItems: 'center' }}
export const RadioCircle = ({ isChecked=false, disabled=false }) => {
    if (isChecked) {
        const circleStyle = disabled ? { borderColor: '#CED1D9' } : {};
        return (
            <div className="radioCircle" style={circleStyle}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: disabled ? '#CED1D9' : '#13b9ab' }}></div>
            </div>
        );
    }
    return (
        <div className="radioCircleUnchecked" />
    );
};